import { Button, Modal } from "react-bootstrap";
import React, { useCallback, useEffect, useState } from "react";
import BaseSelect from "react-select";
import FixRequiredSelect from "../../components/sis/modalcliente/FixRequiredSelect";
import { getAllUsuario } from "../../../api/usuarioApi";
import { getAllCajaEntrada, getAllCajaSalida } from "../../../api/InventarioApi";
import Swal from "sweetalert2";

const options = [
  { value: 1, label: "1 - One" },
  { value: 2, label: "2 - Two" },
  { value: 3, label: "3 - Three" },
];

const Select = (props) => (
  <FixRequiredSelect
    {...props}
    SelectComponent={BaseSelect}
    options={props.options || options}
  />
);

const ModalGastos = (props) => {
  const { estado, onCloseModal, onReturnValue } = props;

  const [listUsuarios, setListUsuario] = useState([]);
  const [productosInventario, setProductosInventario] = useState([]);
  const [esGastoProducto, setEsGastoProducto] = useState(false);
  const [productoRows, setProductoRows] = useState([{ producto: null, cantidad: "1" }]);
  const [loadingInventario, setLoadingInventario] = useState(false);
  const [monto, setmonto] = useState(0);
  // formData3 es el objeto que enviaremos (idUsuario, usuario, gasto, monto, fecha, paraTarifa, paraHonorario, factura)
  const [formData3, setValue] = useState({});

  const addCommas = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9,-]/g, "");
  const handleChange = (event) =>
    setmonto(addCommas(removeNonNumeric(event.target.value)));

  const getPrecioVenta = (item) => {
    const candidates = [
      item?.precioVenta,
      item?.PrecioVenta,
      item?.PRECIOVENTA,
      item?.precio_venta,
      item?.Precio_Venta,
      item?.PRECIO_VENTA,
      item?.precioventa,
      item?.precio,
      item?.Precio,
      item?.PRECIO,
      item?.precio_unitario,
      item?.precioUnitario,
      item?.PRECIO_UNITARIO,
      item?.preciofinal,
      item?.precioFinal,
      item?.PRECIOFINAL,
      item?.venta,
      item?.Venta,
      item?.VENTA,
      item?.precio_venta_unitario,
    ];
    const found = candidates.find((value) => value !== undefined && value !== null && value !== "");
    if (found === undefined) return 0;
    const normalized = String(found).replace(/\./g, "").replace(",", ".");
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const assigmentValue = useCallback(async () => {
    const resultUsuario = await getAllUsuario();
    const filterNumbers = resultUsuario.filter(
      (num) => num.estaActivo !== "Inactivo"
    );
    const resultMapeado = filterNumbers.map((item) => {
      return { label: item.Usuario, value: item.IdUsuario };
    });
    const newList = [{ label: "Otros", value: 0 }, ...resultMapeado];
    setListUsuario(newList);
  }, []);

  const assigmentInventario = useCallback(async () => {
    setLoadingInventario(true);
    try {
      const [entradas, salidas] = await Promise.all([getAllCajaEntrada(), getAllCajaSalida()]);
      const stockMap = {};

      (entradas || []).forEach((item) => {
        const articulo = (item.articulo || item.producto || "").trim().toUpperCase();
        if (!articulo) return;
        if (!stockMap[articulo]) {
          stockMap[articulo] = { articulo, totalEntrada: 0, totalSalida: 0, precioVenta: 0 };
        }
        stockMap[articulo].totalEntrada += Number(item.cantidad) || 0;
        const precioVenta = getPrecioVenta(item);
        if (precioVenta > 0) stockMap[articulo].precioVenta = precioVenta;
      });

      (salidas || []).forEach((item) => {
        const articulo = (item.articulo || item.producto || "").trim().toUpperCase();
        if (!articulo) return;
        if (!stockMap[articulo]) {
          stockMap[articulo] = { articulo, totalEntrada: 0, totalSalida: 0, precioVenta: 0 };
        }
        stockMap[articulo].totalSalida += Number(item.cantidad) || 0;
      });

      const productos = Object.values(stockMap)
        .map((item) => ({ ...item, stockActual: item.totalEntrada - item.totalSalida }))
        .filter((item) => item.stockActual > 0)
        .sort((a, b) => a.articulo.localeCompare(b.articulo));

      setProductosInventario(productos);
    } catch (error) {
      console.error("Error al cargar inventario:", error);
    } finally {
      setLoadingInventario(false);
    }
  }, []);

  useEffect(() => {
    assigmentValue();
    assigmentInventario();
  }, [assigmentValue, assigmentInventario]);

  const productoOptions = productosInventario.map((producto) => ({
    value: producto.articulo,
    label: producto.articulo,
    articulo: producto.articulo,
    precioVenta: producto.precioVenta,
    stockActual: producto.stockActual,
  }));

  const productoSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 48,
    }),
    valueContainer: (base) => ({
      ...base,
      minHeight: 46,
      paddingTop: 6,
      paddingBottom: 6,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const updateProductoRow = (index, field, value) => {
    setProductoRows((prev) => prev.map((row, rowIndex) => (
      rowIndex === index ? { ...row, [field]: value } : row
    )));
  };

  const getProductoRowMonto = (row) => {
    const cantidad = Number(row.cantidad) || 0;
    return (Number(row.producto?.precioVenta) || 0) * cantidad;
  };

  const addProductoRow = () => {
    setProductoRows((prev) => [...prev, { producto: null, cantidad: "1" }]);
  };

  const removeProductoRow = (index) => {
    setProductoRows((prev) => {
      const next = prev.filter((_, rowIndex) => rowIndex !== index);
      return next.length ? next : [{ producto: null, cantidad: "1" }];
    });
  };

  const handleSubmit2 = (event) => {
    event.preventDefault();

    // Normalizaciones / defaults
    formData3.paraTarifa = formData3.paraTarifa ? formData3.paraTarifa : "SI";
    formData3.paraHonorario = formData3.paraHonorario
      ? formData3.paraHonorario
      : "SI";
    formData3.monto = parseInt(removeNonNumeric(monto)) || 0;
    formData3.factura = formData3.factura ? formData3.factura.trim() : ""; // <-- NUEVO
    const hasInventoryProducts = esGastoProducto;
    const validProductRows = productoRows.filter((row) => row.producto);

    // Validaciones básicas
    if (formData3.idUsuario === undefined) {
      Swal.fire({
        title: "Seleccione Profesional",
        icon: "error",
      });
    } else if (!hasInventoryProducts && (formData3.gasto === undefined || formData3.gasto.trim() === "")) {
      Swal.fire({
        title: "Ingrese nombre del gasto",
        icon: "error",
      });
    } else if (!hasInventoryProducts && (formData3.monto === undefined || formData3.monto === 0)) {
      Swal.fire({
        title: "Monto Incorrecto",
        icon: "error",
      });
    } else if (hasInventoryProducts && validProductRows.length === 0) {
      Swal.fire({
        title: "Agregue al menos un producto",
        icon: "error",
      });
    } else if (hasInventoryProducts && validProductRows.some((row) => {
      const cantidad = Number(row.cantidad);
      return !Number.isFinite(cantidad) || cantidad <= 0 || cantidad > Number(row.producto.stockActual);
    })) {
      Swal.fire({
        title: "Revise producto, stock y cantidad",
        icon: "error",
      });
    } else if (!formData3.fecha) {
      Swal.fire({
        title: "Seleccione una fecha",
        icon: "error",
      });
    } else {
      // Enviar al padre (incluye factura ahora)
      if (hasInventoryProducts) {
        onReturnValue(
          validProductRows.map((row) => {
            const cantidad = Number(row.cantidad) || 0;
            return {
              ...formData3,
              gasto: `${row.producto.articulo} x ${cantidad}`,
              monto: (Number(row.producto.precioVenta) || 0) * cantidad,
              esProducto: true,
            };
          })
        );
      } else {
        onReturnValue(formData3);
      }
    }
  };

  return (
    <>
      <Modal show={estado} onHide={onCloseModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Gastos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Profesional
                <span className="text-danger">*</span>
              </label>
              <Select
                options={listUsuarios}
                isSearchable
                required
                onChange={(e) => {
                  setValue({
                    ...formData3,
                    idUsuario: e.value,
                    usuario: e.label,
                  });
                }}
              />
            </div>

            <div className="form-group mb-2 col">
              <label className="col-form-label">
                Factura (opcional)
              </label>
              <div>
                <input
                  type="text"
                  className="form-control"
                  maxLength={50}
                  placeholder="Número / Código de factura"
                  onChange={(e) =>
                    setValue({
                      ...formData3,
                      factura: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="form-group mb-2 col">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="esGastoProductoLiquidacion"
                  checked={esGastoProducto}
                  onChange={(e) => setEsGastoProducto(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="esGastoProductoLiquidacion">
                  Gasto de producto
                </label>
              </div>
            </div>

            {esGastoProducto && (
              <div className="form-group mb-2 col">
                <div className="table-responsive">
                  <table className="table align-middle mb-3" style={{ tableLayout: "fixed", minWidth: 760 }}>
                    <thead>
                      <tr>
                        <th style={{ width: "68%" }}>Producto</th>
                        <th style={{ width: 120 }}>Cantidad</th>
                        <th style={{ width: 140 }}>Monto</th>
                        <th style={{ width: 60 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {productoRows.map((row, index) => (
                        <tr key={index} style={{ height: 72 }}>
                          <td className="py-3">
                            <Select
                              options={productoOptions}
                              isSearchable
                              value={row.producto}
                              onChange={(option) => updateProductoRow(index, "producto", option)}
                              placeholder="Seleccione producto"
                              isLoading={loadingInventario}
                              loadingMessage={() => "Cargando inventario"}
                              noOptionsMessage={() => "Sin productos con stock"}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={productoSelectStyles}
                            />
                          </td>
                          <td className="py-3">
                            <input
                              type="number"
                              className="form-control"
                              min="1"
                              max={row.producto?.stockActual || undefined}
                              value={row.cantidad}
                              onChange={(e) => updateProductoRow(index, "cantidad", e.target.value)}
                              style={{ minHeight: 48 }}
                            />
                          </td>
                          <td className="py-3 text-end">{addCommas(getProductoRowMonto(row))}</td>
                          <td className="py-3">
                            <Button
                              variant="outline-danger"
                              size="sm"
                              type="button"
                              onClick={() => removeProductoRow(index)}
                            >
                              <i className="fa fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <Button variant="outline-primary" size="sm" type="button" onClick={addProductoRow}>
                    Agregar producto
                  </Button>
                </div>
                <small className="text-muted d-block mt-1">
                  Al guardar se crea un gasto separado por cada fila. No se descuenta del stock.
                </small>
              </div>
            )}

            {!esGastoProducto && (
              <>
                <div className="form-group mb-2 col">
                  <label className="col-form-label">
                    Detalle
                    <span className="text-danger">*</span>
                  </label>
                  <div>
                    <textarea
                      className="form-control"
                      rows={4}
                      required
                      onChange={(e) => {
                        setValue({
                          ...formData3,
                          gasto: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="form-group mb-2 col">
                  <label className="col-form-label">
                    Monto
                    <span className="text-danger">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      value={monto}
                      onInput={handleChange}
                      required
                      className="form-control"
                    />
                  </div>
                </div>
              </>
            )}

            <div className="form-group mb-2 col">
              <label className="col-form-label">
                Fecha
                <span className="text-danger">*</span>
              </label>
              <div>
                <input
                  type="date"
                  className="form-control"
                  required
                  onChange={(e) => {
                    setValue({
                      ...formData3,
                      fecha: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="form-group mb-2 row">
              <div className="col">
                <label className="col-form-label">Para Tarifa?</label>
                <div>
                  <select
                    name="paraTarifa"
                    className="form-control"
                    onChange={(e) => {
                      setValue({
                        ...formData3,
                        [e.target.name]: e.target.value,
                      });
                    }}
                    defaultValue="SI"
                  >
                    <option value="SI">Si</option>
                    <option value="NO">No</option>
                  </select>
                </div>
              </div>
              <div className="col">
                <label className="col-form-label">Para Honorario?</label>
                <div>
                  <select
                    name="paraHonorario"
                    className="form-control"
                    onChange={(e) => {
                      setValue({
                        ...formData3,
                        [e.target.name]: e.target.value,
                      });
                    }}
                    defaultValue="SI"
                  >
                    <option value="SI">Si</option>
                    <option value="NO">No</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              onCloseModal();
            }}
          >
            Cerrar
          </Button>
          <Button onClick={handleSubmit2} form="userform">
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalGastos;
